module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select-input', {
    attrs: {
      "label": _vm.label,
      "value-key": "id",
      "label-value": "name",
      "placeholder": _vm.placeholder,
      "size": _vm.size,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.ratesData),
      callback: function($$v) {
        _vm.ratesData = $$v
      },
      expression: "ratesData"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22272f8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectSharerRates.vue
// module id = 1368
// module chunks = 0